<template>
  <div>
    <el-date-picker
      v-model="timeLimit"
      type="monthrange"
      align="right"
      value-format="yyyy-MM"
      unlink-panels
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      :picker-options="pickerOptions"
      :size="size"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
      timeLimit: [],
    };
  },
  props: {
    value: {
      type: Array,
    },
    pickerOptions: Object,
    size: {
      type: String,
      default: 'medium',
    },
  },
  watch: {
    value(timeLimit) {
      if (JSON.stringify(this.timeLimit) === JSON.stringify(timeLimit)) return;

      this.timeLimit = timeLimit;
    },
    timeLimit(timeLimit) {
      if (JSON.stringify(this.value) === JSON.stringify(timeLimit)) return;
      this.$emit('input', timeLimit);
    },
  },
  beforeMount() {
    this.timeLimit = this.value;
  },
};
</script>
